import { render } from "./facilities.vue?vue&type=template&id=ac499c84&scoped=true"
import script from "./facilities.vue?vue&type=script&lang=js"
export * from "./facilities.vue?vue&type=script&lang=js"

import "./facilities.vue?vue&type=style&index=0&id=ac499c84&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac499c84"]])

export default __exports__